module.exports = __webpack_public_path__ + "img/ModuleWorkInProgress.aecc788a.png";